import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// TASK-11/TASK-15 STUB — endpoint may not be integrated yet.
// Uses exact contract from docs/07 §6.
// GET /api/v1/me/teacher/hours/?from=&to=
// → { hours_pending, estimated_amount, rate_applied, hours_paid_history[] }
function useTeacherHours(params = {}) {
  return useQuery({
    queryKey: ["teacher", "hours", params],
    queryFn: () =>
      apiClient
        .get("/api/v1/me/teacher/hours/", { params })
        .then((r) => r.data),
    // Serve cached data instantly on revisits; the figure changes slowly.
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
}

export { useTeacherHours };
